__turbopack_context__.v({
  "backButton": "Modal-module__Wh6uCW__backButton",
  "closeButton": "Modal-module__Wh6uCW__closeButton",
  "content": "Modal-module__Wh6uCW__content",
  "fadeIn": "Modal-module__Wh6uCW__fadeIn",
  "full": "Modal-module__Wh6uCW__full",
  "header": "Modal-module__Wh6uCW__header",
  "lg": "Modal-module__Wh6uCW__lg",
  "md": "Modal-module__Wh6uCW__md",
  "modal": "Modal-module__Wh6uCW__modal",
  "overlay": "Modal-module__Wh6uCW__overlay",
  "slideUp": "Modal-module__Wh6uCW__slideUp",
  "sm": "Modal-module__Wh6uCW__sm",
  "title": "Modal-module__Wh6uCW__title",
});
